import { FunctionsRepository as FirebaseFunctionsRepository } from './Firebase/FunctionsRepository';
import { FirebaseConnection } from './Firebase/FirebaseConnection';
import { ThreadRepository } from './ThreadRepository';
import { LocalStrageRepository } from './LocalStorage/LocalStrageRepository';
import { DataCallback } from './DataCallback';
import { Functions } from '../Entities/Function';
import { JsonToFunctions } from '../Entities/JsonToFunctions';
export class FunctionsRepository extends ThreadRepository {
  public static readonly STORAGE_KEY = 'STORAGE_KEY_';
  private localRepository = new LocalStrageRepository();

  public constructor(private con: FirebaseConnection) {
    super();
    this.firestore = new FirebaseFunctionsRepository(con);
  }

  public async getAll(callback: DataCallback): Promise<boolean> {
    const stringfyFunctions = this.localRepository.get(FunctionsRepository.STORAGE_KEY + this.con.authUid);
    if (stringfyFunctions) {
      const jsonToFunctions = new JsonToFunctions(stringfyFunctions);
      const functions = jsonToFunctions.toFunctions();
      callback.setData(FunctionsRepository.STORAGE_KEY, functions);
      return true;
    }

    if (this.firestore) {
      await this.firestore.getAll(callback);
      return true;
    }

    return false;
  }

  public save(functions: Functions): void {
    //console.log(0, functions.toPlainObject());
    this.localRepository.save(FunctionsRepository.STORAGE_KEY, JSON.stringify(functions.toPlainObject()));
  }

  hasChildRepository(): boolean {
    return false;
  }
  childRepository(id: string): ThreadRepository {
    throw new Error("Method not implemented.");
  }
}